import {  useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Caption,
  fetchTranslations,
  getCaptions,
  translationsStatus,
} from './translationsSlice'

const useTranslation = (namespace: string) => {
    const dispatch = useDispatch();
    const status = useSelector(translationsStatus)
    const captions: Caption[] = useSelector(getCaptions)
    const t = (caption: string): string => captions.find(c => c.key === caption)?.value ?? caption

    useEffect(() => {
      if (status === 'idle' && captions.length === 0) {
          dispatch(fetchTranslations())
      }
        // return () => { }  
    })
    
    return { t }

}
export default useTranslation